
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  maxTocLevel: 4,
  layout: 'reference',
  description: 'API reference for endpoints for use by Plaid partners',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Processor partner endpoints' subtitle={metadata.description} mdxType="Header" />
    <p>{`Partner processor endpoints are used by Plaid partners to integrate with Plaid. Instead of using an `}<inlineCode parentName="p">{`access_token`}</inlineCode>{` associated with a Plaid `}<inlineCode parentName="p">{`Item`}</inlineCode>{`, these endpoints use a `}<inlineCode parentName="p">{`processor_token`}</inlineCode>{` to identify a single financial account. These endpoints are used only by partners and not by developers who are using those partners' APIs. If you are a Plaid developer who would like to use a partner, see `}<a parentName="p" {...{
        "href": "/docs/api/processors"
      }}>{`Processor token endpoints`}</a>{`. To learn how to move money with one of our partners, see `}<a parentName="p" {...{
        "href": "/docs/auth/partnerships"
      }}>{`Move money with Auth`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`In this section`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/account/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Account data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/auth/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Auth data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/balance/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Balance data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/identity/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Identity data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/identity/match`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Identity match scores`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/investments/auth/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Investments Auth data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/investments/holdings/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Investments Holdings data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/investments/transactions/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch Investments Transactions data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/liabilities/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Liabilities data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/signal/evaluate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Signal scores`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/signal/decision/report`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Report whether you initiated an ACH transaction`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/signal/return/report`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Report a return for an ACH transaction`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/signal/prepare`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Prepare a processor token for Signal`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/token/webhook/update`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set the webhook URL for a processor token`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/sync`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get transaction data or incremental transaction updates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/recurring/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch recurring transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/refresh`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh transaction data`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#webhook_update_acknowledged"
            }}><inlineCode parentName="a">{`WEBHOOK_UPDATE_ACKNOWLEDGED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Item's webhook receiver endpoint has been updated`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "processoraccountget"
    }}>{`/processor/account/get`}</h4>
    <Schema method='POST' route='/processor/account/get' type="request" mdxType="Schema">
      <MDXCodeBlock title="/processor/account/get" type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl \\
-H 'Content-Type: application/json' \\
-d '{
"client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
"secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
"processor_token": "\${PROCESSOR_TOKEN}"
}' \\
-X POST \\
https://sandbox.plaid.com/processor/account/get
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorAccountGetRequest request = new ProcessorAccountGetRequest()
.processorToken(processorToken);

Response<ProcessorAccountGetResponse> response = client()
.processorAccountGet(request)
.execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`processor_account_get_request = Plaid::ProcessorAccountGetRequest.new(
{
  processor_token: processor_token,
}
)
response = client.processor_account_get(processor_account_get_request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorAccountGetRequest(
processor_token=processor_token,
)
response = client.processor_account_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const request: ProcessorAccountGetRequest = {
    processor_token: processorToken,
  };
  const response = await plaidClient.processorAccountGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`ProcessorAccountGetResp, _, err := client.PlaidApi.ProcessorAccountGet(ctx).ProcessorAccountGetRequest(
*plaid.NewProcessorAccountGetRequest(processorToken),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`ProcessorAccountGetResp, err := client.Processor.GetAccount(ctx, &plaid.ProcessorAccountGetRequest{ProcessorToken: processorToken})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/account/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorauthget"
    }}>{`/processor/auth/get`}</h4>
    <Schema method='POST' route='/processor/auth/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/auth/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/auth/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorAuthGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorAuthGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorAuthGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorAuthGet(ctx).ProcessorAuthGetRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorAuthGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetAuth(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorAuthGetRequest.new({ processor_token: processor_token })
response = client.processor_auth_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorAuthGetRequest(
    processor_token=processor_token,
    )
response = client.processor_auth_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorAuthGetRequest request = new ProcessorAuthGetRequest()
  .processorToken(processorToken);
Response<ProcessorAuthGetResponse> response = client()
  .processorAuthGet(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/auth/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorbalanceget"
    }}>{`/processor/balance/get`}</h4>
    <Schema method='POST' route='/processor/balance/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/balance/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/balance/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorBalanceGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorBalanceGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorBalanceGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorBalanceGet(ctx).ProcessorBalanceGetRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorBalanceGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetBalance(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorBalanceGetRequest.new({ processor_token: processor_token })
response = client.processor_balance_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorBalanceGetRequest(
    processor_token=processor_token,
)
response = client.processor_balance_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorBalanceGetRequest request = new ProcessorBalanceGetRequest()
  .processorToken(processorToken);
Response<ProcessorBalanceGetResponse> response = client()
  .processorBalanceGet(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/balance/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processoridentityget"
    }}>{`/processor/identity/get`}</h4>
    <Schema method='POST' route='/processor/identity/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/identity/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/identity/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorIdentityGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorIdentityGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorIdentityGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorIdentityGet(ctx).ProcessorIdentityGetRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorIdentityGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetIdentity(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorIdentityGetRequest.new({ processor_token: processor_token })
response = client.processor_identity_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorIdentityGetRequest(
    processor_token=processor_token,
)
response = client.processor_identity_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorIdentityGetRequest request = new ProcessorIdentityGetRequest()
  .processorToken(processorToken);
Response<ProcessorIdentityGetResponse> response = client()
  .processorIdentityGet(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/identity/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processoridentitymatch"
    }}>{`/processor/identity/match`}</h4>
    <Schema method='POST' route='/processor/identity/match' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/identity/match' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/identity/match \\
-H 'Content-Type: application/json' \\
-d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorIdentityMatchRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorIdentityMatch(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorIdentityMatchRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorIdentityMatch(ctx).ProcessorIdentityMatchRequest(
    *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorIdentityMatchRequest{ProcessorToken: processorToken}
response, err := client.Processor.MatchIdentity(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorIdentityMatchRequest.new({ processor_token: processor_token })
response = client.processor_identity_match(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorIdentityMatchRequest(
    processor_token=processor_token,
)
response = client.processor_identity_match(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorIdentityMatchRequest request = new ProcessorIdentityMatchRequest()
    .processorToken(processorToken);
Response<ProcessorIdentityMatchResponse> response = client()
    .processorIdentityMatch(request)
    .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/identity/match' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorinvestmentsauthget"
    }}>{`/processor/investments/auth/get`}</h4>
    <Schema method='POST' route='/processor/investments/auth/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/investments/auth/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/investments/auth/get \\
-H 'Content-Type: application/json' \\
-d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorInvestmentsAuthGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorInvestmentsAuthGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorInvestmentsAuthGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorInvestmentsAuthGet(ctx).ProcessorInvestmentsAuthGetRequest(
    *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorInvestmentsAuthGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetInvestmentAuth(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorInvestmentsAuthGetRequest.new({ processor_token: processor_token })
response = client.processor_investments_auth_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorInvestmentsAuthGetRequest(
    processor_token=processor_token,
)
response = client.processor_investments_auth_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorInvestmentsAuthGetRequest request = new ProcessorInvestmentsAuthGetRequest()
    .processorToken(processorToken);
Response<ProcessorInvestmentsAuthGetResponse> response = client()
    .processorInvestmentsAuthGet(request)
    .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/investments/auth/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorinvestmentsholdingsget"
    }}>{`/processor/investments/holdings/get`}</h4>
    <Schema method='POST' route='/processor/investments/holdings/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/investments/holdings/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/investments/holdings/get \\
-H 'Content-Type: application/json' \\
-d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorInvestmentsHoldingsGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorInvestmentsHoldingsGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorInvestmentsHoldingsGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorInvestmentsHoldingsGet(ctx).ProcessorInvestmentsHoldingsGetRequest(
    *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorInvestmentsHoldingsGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetInvestmentHoldings(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorInvestmentsHoldingsGetRequest.new({ processor_token: processor_token })
response = client.processor_investments_holdings_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorInvestmentsHoldingsGetRequest(
    processor_token=processor_token,
)
response = client.processor_investments_holdings_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorInvestmentsHoldingsGetRequest request = new ProcessorInvestmentsHoldingsGetRequest()
    .processorToken(processorToken);
Response<ProcessorInvestmentsHoldingsGetResponse> response = client()
    .processorInvestmentsHoldingsGet(request)
    .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/investments/holdings/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorinvestmentstransactionsget"
    }}>{`/processor/investments/transactions/get`}</h4>
    <Schema method='POST' route='/processor/investments/transactions/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/investments/transactions/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/investments/transactions/get \\
-H 'Content-Type: application/json' \\
-d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "processor_token": String,
    "start_date": "2024-01-01",
    "end_date": "2024-03-31"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorInvestmentsTransactionsGetRequest = {
  processor_token: processorToken,
  start_date: '2024-01-01',
  end_date: '2024-03-31',
};
const response = await plaidClient.processorInvestmentsTransactionsGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorInvestmentsTransactionsGetRequest(processorToken, "2024-01-01", "2024-03-31")
response, _, err := client.PlaidApi.ProcessorInvestmentsTransactionsGet(ctx).ProcessorInvestmentsTransactionsGetRequest(
    *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorInvestmentsTransactionsGetRequest{
    ProcessorToken: processorToken,
    StartDate:      time.Date(2024, 1, 1, 0, 0, 0, 0, time.UTC),
    EndDate:        time.Date(2024, 3, 31, 0, 0, 0, 0, time.UTC),
}
response, err := client.Processor.GetInvestmentTransactions(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorInvestmentsTransactionsGetRequest.new({ processor_token: processor_token, start_date: '2024-01-01', end_date: '2024-03-31' })
response = client.processor_investments_transactions_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorInvestmentsTransactionsGetRequest(
    processor_token=processor_token,
    start_date=datetime.date(2024, 1, 1),
    end_date=datetime.date(2024, 3, 31),
)
response = client.processor_investments_transactions_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorInvestmentsTransactionsGetRequest request = new ProcessorInvestmentsTransactionsGetRequest()
    .processorToken(processorToken)
    .startDate(LocalDate.parse("2024-01-01"))
    .endDate(LocalDate.parse("2024-03-31"));
Response<ProcessorInvestmentsTransactionsGetResponse> response = client()
    .processorInvestmentsTransactionsGet(request)
    .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/investments/transactions/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorsignalevaluate"
    }}>{`/processor/signal/evaluate`}</h4>
    <Schema method='POST' route='/processor/signal/evaluate' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/signal/evaluate' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const eval_request = {
  processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
  client_transaction_id: 'txn12345',
  amount: 123.45,
  client_user_id: 'user1234',
  user: {
    name: {
      prefix: 'Ms.',
      given_name: 'Jane',
      middle_name: 'Leah',
      family_name: 'Doe',
      suffix: 'Jr.',
    },
    phone_number: '+14152223333',
    email_address: 'jane.doe@example.com',
    address: {
      street: '2493 Leisure Lane',
      city: 'San Matias',
      region: 'CA',
      postal_code: '93405-2255',
      country: 'US',
    },
  },
  device: {
    ip_address: '198.30.2.2',
    user_agent:
      'Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1',
  },
  user_present: true,
};

try {
  const eval_response = await plaidClient.processorSignalEvaluate(eval_request);
  const core_attributes = eval_response.data.core_attributes;
  const scores = eval_response.data.scores;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/signal/evaluate \\
-H 'Content-Type: application/json' \\
-d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "processor_token": "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
   "client_transaction_id": "txn12345",
   "amount": 123.45,
   "client_user_id": "user1234",
   "user": {
     "name": {
       "prefix": "Ms.",
       "given_name": "Jane",
       "middle_name": "Leah",
       "family_name": "Doe",
       "suffix": "Jr."
     },
     "phone_number": "+14152223333",
     "email_address": "jane.doe@example.com",
     "address": {
       "street": "2493 Leisure Lane",
       "city": "San Matias",
       "region": "CA",
       "postal_code": "93405-2255",
       "country": "US"
     }
   },
   "device": {
     "ip_address": "198.30.2.2",
     "user_agent": "Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1"
   },
   "user_present": true
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`signalUser = Plaid::SignalUser.new(
  {
    name: Plaid::SignalPersonName.new(
      {
        prefix: 'Ms.',
        given_name: 'Jane',
        middle_name: 'Leah',
        family_name: 'Doe',
        suffix: 'Jr.'
      }
    ),
    phone_number: '+14152223333',
    email_address: 'jane.doe@example.com',
    address: Plaid::SignalAddressData.new(
      {
        city: 'San Matias',
        region: 'CA',
        street: '2493 Leisure Lane',
        postal_code: '93405-2255',
        country: 'US'
      }
    )
  }
)

signalDevice = Plaid::SignalDevice.new(
  {
    ip_address: '198.30.2.2',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1'
  }
)

request = Plaid::ProcessorSignalEvaluateRequest.new(
  {
    processor_token: processor_token,
    client_transaction_id: 'txn12345',
    amount: 123.45,
    client_user_id: 'user1234',
    user: signalUser,
    device: signalDevice,
    user_present: true
  }
)
response = client.processor_signal_evaluate(request)
scores = response.scores
core_attributes = response.core_attributes
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`SignalPersonName signalPersonName = new SignalPersonName()
  .prefix("Ms.")
  .givenName("Jane")
  .middleName("Leah")
  .familyName("Doe")
  .suffix("Jr.");
SignalAddressData signalAddressData = new SignalAddressData()
  .street("2493 Leisure Lane")
  .city("San Matias")
  .region("CA")
  .postalCode("93405-2255")
  .country("US");
SignalDevice signalDevice = new SignalDevice()
  .ipAddress("198.30.2.2")
  .userAgent("Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1");
SignalUser signalUser = new SignalUser()
  .name(signalPersonName)
  .phoneNumber("+14152223333")
  .emailAddress("jane.doe@example.com")
  .address(signalAddressData);
ProcessorSignalEvaluateRequest request = new ProcessorSignalEvaluateRequest()
  .processorToken("processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175")
  .clientTransactionId("txn12345")
  .amount(123.45)
  .user(signalUser)
  .device(signalDevice)
  .userPresent(true);

Response<ProcessorSignalEvaluateResponse> response = plaidClient()
  .processorSignalEvaluate(request)
  .execute();
SignalScores scores = response.body().getScores();
SignalEvaluateCoreAttributes coreAttributes = response.body().getCoreAttributes();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorSignalEvaluateRequest(
  processor_token="processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  client_transaction_id="txn123",
  amount=123.45,
  client_user_id="user1234",
  user=SignalUser(
    name=SignalPersonName(
      prefix="Ms.",
      given_name="Jane",
      middle_name="Leah",
      family_name="Doe",
      suffix="Jr.",
    ),
    phone_number="+14152223333",
    email_address="jane.doe@example.com",
    address=SignalAddressData(
      street="2493 Leisure Lane",
      city="San Matias",
      region="CA",
      postal_code="93405-2255",
      country="US"
    )
  ),
  device=SignalDevice(
    ip_address="198.30.2.2",
    user_agent="Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1"
  ),
  user_present=True,
)

response = client.processor_signal_evaluate(request)
core_attributes = response['core_attributes']
scores = response['scores']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorSignalEvaluateRequest(
  "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  "txn12345",
  123.45,
)
request.SetClientUserId("user1234")
signalName := plaid.NewSignalPersonName()
signalName.SetPrefix("Ms.")
signalName.SetGivenName("Jane")
signalName.SetMiddleName("Leah")
signalName.SetFamilyName("Doe")
signalName.SetSuffix("Jr.")
phoneNumber := "+14152223333"
emailAddress := "jane.doe@example.com"
address := plaid.NewSignalAddressData()
address.SetCity("San Matias")
address.SetRegion("CA")
address.SetStreet("2493 Leisure Lane")
address.SetPostalCode("93405-2255")
address.SetCountry("US")
request.SetUser(plaid.SignalUser {
    Name: *plaid.NewNullableSignalPersonName(signalName),
    PhoneNumber: *plaid.NewNullableString(&phoneNumber),
    EmailAddress: *plaid.NewNullableString(&emailAddress),
    Address: *plaid.NewNullableSignalAddressData(address),
  },
)
device := plaid.NewSignalDevice()
device.SetIpAddress("198.30.2.2")
device.SetUserAgent("Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1")
request.SetDevice(*device)
request.SetUserPresent(true)
response, _, err := client.PlaidApi.ProcessorSignalEvaluate(ctx).ProcessorSignalEvaluateRequest(*request).Execute()
scores := response.GetScores()
coreAttributes := response.GetCoreAttributes()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    processor "github.com/plaid/plaid-go/v49/processor"
)

request := &processor.ProcessorSignalEvaluateRequest{
    ProcessorToken:      "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
    ClientTransactionID: "txn12345",
    Amount:              123.45,
}
request.ClientUserID = plaid.String("user1234")
signalName := &plaid.SignalPersonName{}
signalName.Prefix = plaid.String("Ms.")
signalName.GivenName = plaid.String("Jane")
signalName.MiddleName = plaid.String("Leah")
signalName.FamilyName = plaid.String("Doe")
signalName.Suffix = plaid.String("Jr.")
phoneNumber := "+14152223333"
emailAddress := "jane.doe@example.com"
address := &plaid.SignalAddressData{}
address.City = plaid.String("San Matias")
address.Region = plaid.String("CA")
address.Street = plaid.String("2493 Leisure Lane")
address.PostalCode = plaid.String("93405-2255")
address.Country = plaid.String("US")
request.User = &plaid.SignalUser{
    Name:         signalName,
    PhoneNumber:  &phoneNumber,
    EmailAddress: &emailAddress,
    Address:      address,
}
device := &plaid.SignalDevice{}
device.IPAddress = plaid.String("198.30.2.2")
device.UserAgent = plaid.String("Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Mobile/15E148 Safari/604.1")
request.Device = device
request.UserPresent = plaid.Bool(true)
response, err := client.Processor.Signal.Evaluate(ctx, request)
scores := response.GetScores()
coreAttributes := response.GetCoreAttributes()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/signal/evaluate' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorliabilitiesget"
    }}>{`/processor/liabilities/get`}</h4>
    <Schema method='POST' route='/processor/liabilities/get' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/liabilities/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/liabilities/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorLiabilitiesGetRequest = {
  processor_token: processorToken,
};
const response = await plaidClient.processorLiabilitiesGet(request);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorLiabilitiesGetRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorLiabilitiesGet(ctx).ProcessorLiabilitiesGetRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorLiabilitiesGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetLiabilities(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorLiabilitiesGetRequest.new({ processor_token: processor_token })
response = client.processor_liabilities_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorLiabilitiesGetRequest(
    processor_token=processor_token,
)
response = client.processor_liabilities_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorLiabilitiesGetRequest request = new ProcessorLiabilitiesGetRequest()
  .processorToken(processorToken);
Response<ProcessorLiabilitiesGetResponse> response = client()
  .processorLiabilitiesGet(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/liabilities/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorsignaldecisionreport"
    }}>{`/processor/signal/decision/report`}</h4>
    <Schema method='POST' route='/processor/signal/decision/report' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/signal/decision/report' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const decision_report_request = {
  processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
  client_transaction_id: 'txn12345',
  initiated: true,
  days_funds_on_hold: 3,
};

try {
  const decision_report_response =
    await plaidClient.processorSignalDecisionReport(decision_report_request);
  const decision_request_id = decision_report_response.data.request_id;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/signal/decision/report \\
-H 'content-type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "processor_token": "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
   "client_transaction_id": "txn123",
   "initiated": true
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorSignalDecisionReportRequest.new(
  {
    processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
    client_transaction_id: 'txn12345',
    initiated: true,
    days_funds_on_hold: 3
  }
)
response = client.processor_signal_decision_report(request)
request_id = response.request_id
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorSignalDecisionReportRequest request = new ProcessorSignalDecisionReportRequest()
  .processorToken("processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175")
  .clientTransactionId("txn12345")
  .initiated(true)
  .daysFundsOnHold(3);

Response<ProcessorSignalDecisionReportResponse> response = plaidClient()
  .processorSignalDecisionReport(request)
  .execute();
String requestID = response.body().getRequestId();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorSignalDecisionReportRequest(
  processor_token="processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  client_transaction_id="txn12345",
  initiated=True,
  days_funds_on_hold=3,
)
response = client.processor_signal_decision_report(request)
request_id = response['request_id']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorSignalDecisionReportRequest(
  "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  "txn12345",
  true,
)
request.SetDaysFundsOnHold(3)
response, _, err := client.PlaidApi.ProcessorSignalDecisionReport(ctx).ProcessorSignalDecisionReportRequest(*request).Execute()
request_id := response.GetRequestId()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    processor "github.com/plaid/plaid-go/v49/processor"
)

request := &processor.ProcessorSignalDecisionReportRequest{
    ProcessorToken:      "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
    ClientTransactionID: "txn12345",
    Initiated:           true,
}
request.DaysFundsOnHold = plaid.Int(3)
response, err := client.Processor.Signal.ReportDecision(ctx, request)
request_id := response.GetRequestID()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/signal/decision/report' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorsignalreturnreport"
    }}>{`/processor/signal/return/report`}</h4>
    <Schema method='POST' route='/processor/signal/return/report' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/signal/return/report' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const return_report_request = {
  processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
  client_transaction_id: 'txn12345',
  return_code: 'R01',
};

try {
  const return_report_response = await plaidClient.processorSignalReturnReport(
    return_report_request,
  );
  const request_id = return_report_response.data.request_id;
  console.log(request_id);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/signal/return/report \\
-H 'content-type: application/json' \\
-d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "processor_token": "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
   "client_transaction_id": "txn12345",
   "return_code": "R01"
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorSignalReturnReportRequest.new(
  {
    processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
    client_transaction_id: 'txn12345',
    return_code: 'R01'
  }
)
response = client.processor_signal_return_report(request)
request_id = response.request_id
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorSignalReturnReportRequest request = new ProcessorSignalReturnReportRequest()
  .processorToken("processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175")
  .clientTransactionId("txn12345")
  .returnCode("R01");

Response<ProcessorSignalReturnReportResponse> response = client()
  .processorSignalReturnReport(request)
  .execute();

String requestId = response.body().getRequestId();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorSignalReturnReportRequest(
  processor_token="processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  client_transaction_id="txn12345",
  return_code="R01",
)
response = client.processor_signal_return_report(request)
request_id = response['request_id']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorSignalReturnReportRequest(
  "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
  "txn12345",
  "R01",
)
response, _, err := client.PlaidApi.ProcessorSignalReturnReport(ctx).ProcessorSignalReturnReportRequest(*request).Execute()
request_id := response.GetRequestId()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    processor "github.com/plaid/plaid-go/v49/processor"
)

request := &processor.ProcessorSignalReturnReportRequest{
    ProcessorToken:      "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
    ClientTransactionID: "txn12345",
    ReturnCode:          "R01",
}
response, err := client.Processor.Signal.ReportReturn(ctx, request)
request_id := response.GetRequestID()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/signal/return/report' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processorsignalprepare"
    }}>{`/processor/signal/prepare`}</h4>
    <Schema method='POST' route='/processor/signal/prepare' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/signal/prepare' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const prepare_request = {
  processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
};

try {
  const prepare_response =
    await plaidClient.processorSignalPrepare(prepare_request);
  const prepare_request_id = prepare_response.data.request_id;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/signal/prepare \\
-H 'content-type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "processor_token": "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175"
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorSignalPrepareRequest.new(
  {
    processor_token: 'processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175',
  }
)
response = client.processor_signal_prepare(request)
request_id = response.request_id
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorSignalPrepareRequest request = new ProcessorSignalPrepareRequest()
  .processorToken("processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175");

Response<ProcessorSignalPrepareResponse> response = plaidClient()
  .processorSignalPrepare(request)
  .execute();
String requestID = response.body().getRequestId();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorSignalPrepareRequest(
  processor_token="processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
)
response = client.processor_signal_prepare(request)
request_id = response['request_id']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorSignalPrepareRequest(
  "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
)
response, _, err := client.PlaidApi.ProcessorSignalPrepare(ctx).ProcessorSignalPrepareRequest(*request).Execute()
request_id := response.GetRequestId()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    processor "github.com/plaid/plaid-go/v49/processor"
)

request := &processor.ProcessorSignalPrepareRequest{
    ProcessorToken: "processor-sandbox-71e02f71-0960-4a27-abd2-5631e04f2175",
}
response, err := client.Processor.Signal.Prepare(ctx, request)
request_id := response.GetRequestID()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/signal/prepare' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processortokenwebhookupdate"
    }}>{`/processor/token/webhook/update`}</h4>
    <Schema method='POST' route='/processor/token/webhook/update' type="request" mdxType="Schema">
      <MDXCodeBlock title='/processor/token/webhook/update' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl \\
  -H 'Content-Type: application/json' \\
  -d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": "\${PROCESSOR_TOKEN}",
  "webhook": "https://www.example-webhook.com"
  }' \\
  -X POST \\
  https://sandbox.plaid.com/processor/token/webhook/update
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorTokenWebhookUpdateRequest request = new ProcessorTokenWebhookUpdateRequest()
.processorToken(processorToken)
.webhook(webhook);

Response<ProcessorTokenWebhookUpdateResponse> response = client()
.processorTokenWebhookUpdate(request)
.execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`processor_token_webhook_update_request = Plaid::ProcessorTokenWebhookUpdateRequest.new(
  {
    processor_token: processor_token,
    webhook: webhook,
  }
)
response = client.processor_token_webhook_update(processor_token_webhook_update_request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorTokenWebhookUpdateRequest(
  processor_token=processor_token,
  webhook=webhook,
)
response = client.processor_token_webhook_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const request: ProcessorTokenWebhookUpdateRequest = {
    processor_token: processorToken,
    webhook: webhook,
  };
  const response = await plaidClient.processorTokenWebhookUpdate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`processorTokenWebhookUpdateResp, _, err := client.PlaidApi.ProcessorTokenWebhookUpdate(ctx).ProcessorTokenWebhookUpdateRequest(
  *plaid.NewProcessorTokenWebhookUpdateRequest(processorToken, webhook),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`processorTokenWebhookUpdateResp, err := client.Processor.UpdateTokenWebhook(ctx, &plaid.ProcessorTokenWebhookUpdateRequest{
    ProcessorToken: processorToken,
    Webhook:        &webhook,
})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/token/webhook/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processortransactionssync"
    }}>{`/processor/transactions/sync`}</h4>
    <Schema method='POST' route='/processor/transactions/sync' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/transactions/sync' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
let cursor = database.getLatestCursorOrNull(itemId);

// New transaction updates since "cursor"
let added: Array<Transaction> = [];
let modified: Array<Transaction> = [];
// Removed transaction ids
let removed: Array<RemovedTransaction> = [];
let hasMore = true;

// Iterate through each page of new transaction updates for item
while (hasMore) {
  const request: ProcessorTransactionsSyncRequest = {
    processor_token: processorToken,
    cursor: cursor,
  };
  const response = await client.processorTransactionsSync(request);
  const data = response.data;

  // Add this page of results
  added = added.concat(data.added);
  modified = modified.concat(data.modified);
  removed = removed.concat(data.removed);

  hasMore = data.has_more;

  // Update cursor to the next cursor
  cursor = data.next_cursor;
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/transactions/sync \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String,
  "cursor": String,
  "count": 250
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# Provide a cursor from your database if you've previously
# received one for the Item. Leave null if this is your
# first sync call for this item. The first request will
# return a cursor.
cursor = database.get_latest_cursor_or_none(item_id)

# New transaction updates since "cursor"
added = []
modified = []
removed = [] # Removed transaction ids
has_more = true

# Iterate through each page of new transaction updates for item
while has_more
  request = Plaid::ProcessorTransactionsSyncRequest.new(
    {
      processor_token: processor_token,
      cursor: cursor
    }
  )

  response = client.processor_transactions_sync(request)

  # Add this page of results
  added += response.added
  modified += response.modified
  removed += response.removed

  has_more = response.has_more

  # Update cursor to the next cursor
  cursor = response.next_cursor
end

# Persist cursor and updated data
database.apply_updates(item_id, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the item leave null if this is your
// first sync call for this item. The first request will
// return a cursor.
String cursor = database.getLatestCursorOrNull(itemId);

// New transaction updates since "cursor"
List<Transaction> added = new ArrayList<Transaction>();
List<Transaction> modified = new ArrayList<Transaction>();
List<RemovedTransaction> removed = new ArrayList<RemovedTransaction>();
boolean hasMore = true;

// Iterate through each page of new transaction updates for item
while (hasMore) {
  ProcessorTransactionsSyncRequest request = new ProcessorTransactionsSyncRequest()
    .processorToken(processorToken)
    .cursor(cursor);

  ProcessorTransactionsSyncResponse response = plaidClient.processorTransactionsSync(request).execute().body();

  // Add this page of results
  added.addAll(response.getAdded());
  modified.addAll(response.getModified());
  removed.addAll(response.getRemoved());

  hasMore = response.getHasMore();

  // Update cursor to the next cursor
  cursor = response.getNextCursor();
}
// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# Provide a cursor from your database if you've previously
# received one for the Item. Leave null if this is your
# first sync call for this Item. The first request will
# return a cursor.
cursor = database.get_latest_cursor_or_none(item_id)

# New transaction updates since "cursor"
added = []
modified = []
removed = [] # Removed transaction ids
has_more = True

# Iterate through each page of new transaction updates for item
while has_more:
  request = ProcessorTransactionsSyncRequest(
    processor_token=processor_token,
    cursor=cursor,
  )
  response = plaid_client.processor_transactions_sync(request)

  # Add this page of results
  added.extend(response['added'])
  modified.extend(response['modified'])
  removed.extend(response['removed'])

  has_more = response['has_more']

  # Update cursor to the next cursor
  cursor = response['next_cursor']

# Persist cursor and updated data
database.apply_updates(item_id, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
cursor := database.getLatestCursorOrNil(itemId)

// New transaction updates since "cursor"
var added []plaid.Transaction
var modified []plaid.Transaction
var removed []plaid.RemovedTransaction // Removed transaction ids
hasMore := true

// Iterate through each page of new transaction updates for item
for hasMore {
  request := plaid.NewProcessorTransactionsSyncRequest(processorToken)
  if cursor != nil {
    request.SetCursor(*cursor)
  }
  resp, _, err := client.PlaidApi.ProcessorTransactionsSync(
    ctx,
  ).ProcessorTransactionsSyncRequest(*request).Execute()

  // Add this page of results
  added = append(added, resp.GetAdded()...)
  modified = append(modified, resp.GetModified()...)
  removed = append(removed, resp.GetRemoved()...)

  hasMore = resp.GetHasMore()

  // Update cursor to the next cursor
  nextCursor := resp.GetNextCursor()
  cursor = &nextCursor
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
cursor := database.getLatestCursorOrNil(itemId)

// New transaction updates since "cursor"
var added []*plaid.Transaction
var modified []*plaid.Transaction
var removed []*plaid.RemovedTransaction // Removed transaction ids
hasMore := true

// Iterate through each page of new transaction updates for item
for hasMore {
    request := &plaid.ProcessorTransactionsSyncRequest{ProcessorToken: processorToken}
    if cursor != nil {
        request.Cursor = cursor
    }
    resp, err := client.Processor.SyncTransactions(ctx, request)

    // Add this page of results
    added = append(added, resp.GetAdded()...)
    modified = append(modified, resp.GetModified()...)
    removed = append(removed, resp.GetRemoved()...)

    hasMore = resp.GetHasMore()

    // Update cursor to the next cursor
    nextCursor := resp.GetNextCursor()
    cursor = &nextCursor
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/transactions/sync' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processortransactionsget"
    }}>{`/processor/transactions/get`}</h4>
    <Schema method='POST' route='/processor/transactions/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/transactions/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorTransactionsGetRequest = {
  processor_token: processorToken,
  start_date: '2018-01-01',
  end_date: '2020-02-01'
};
try {
  const response = await client.processorTransactionsGet(request);
  let transactions = response.data.transactions;
  const total_transactions = response.data.total_transactions;
  // Manipulate the offset parameter to paginate
  // transactions and retrieve all available data
  while (transactions.length < total_transactions) {
    const paginatedRequest: ProcessorTransactionsGetRequest = {
      processor_token: processorToken,
      start_date: '2018-01-01',
      end_date: '2020-02-01',
      options: {
        offset: transactions.length,
      },
    };
    const paginatedResponse = await client.processorTransactionsGet(paginatedRequest);
    transactions = transactions.concat(
      paginatedResponse.data.transactions,
    );
  }
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/transactions/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "processor_token": String,
  "start_date": "2018-01-01",
  "end_date": "2018-02-01",
  "options": {
    "count": 250,
    "offset": 100
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# Pull transactions for a date range
request = Plaid::ProcessorTransactionsGetRequest.new(
  {
    processor_token: processor_token,
    start_date: '2018-01-01',
    end_date: '2018-02-01'
  }
)
response = client.processor_transactions_get(request)
transactions = response.transactions

# Manipulate the offset parameter to paginate
# transactions and retrieve all available data
while transactions.length < response.total_transactions
  request = Plaid::ProcessorTransactionsGetRequest.new(
    {
    processor_token: processor_token,
    start_date: '2018-01-01',
    end_date: '2018-02-01',
    options: { offset: transactions.length }
    }
  )
  response = client.processor_transactions_get(request)
  transactions += response.transactions
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`LocalDate startDate = LocalDate.parse("2018-01-01");
LocalDate endDate = LocalDate.parse("2018-02-01");
// Pull transactions for a date range

ProcessorTransactionsGetRequest request = new ProcessorTransactionsGetRequest()
  .processorToken(processorToken)
  .startDate(startDate)
  .endDate(endDate);
Response<ProcessorTransactionsGetResponse>
  response = plaidClient.processorTransactionsGet(request).execute();

List<Transaction> transactions = new ArrayList <Transaction>();
transactions.addAll(response.body().getTransactions());

// Manipulate the offset parameter to paginate
// transactions and retrieve all available data
while (transactions.size() < response.body().getTotalTransactions()) {
  ProcessorTransactionsGetRequestOptions options = new ProcessorTransactionsGetRequestOptions()
    .offset(transactions.size());

  request = new ProcessorTransactionsGetRequest()
    .processorToken(processorToken)
    .startDate(startDate)
    .endDate(endDate)
    .options(options);

  response = plaidClient.processorTransactionsGet(request).execute();
  transactions.addAll(response.body().getTransactions());
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorTransactionsGetRequest(
            processor_token=processor_token,
            start_date=datetime.date(2020, 1, 1),
            end_date=datetime.date(2021, 2, 1),
            options=ProcessorTransactionsGetRequestOptions()
)
response = client.processor_transactions_get(request)
transactions = response['transactions']

# Manipulate the count and offset parameters to paginate
# transactions and retrieve all available data
while len(transactions) < response['total_transactions']:
  request = ProcessorTransactionsGetRequest(
              processor_token=processor_token,
              start_date=datetime.date(2020, 1, 1),
              end_date=datetime.date(2021, 2, 1),
              options=ProcessorTransactionsGetRequestOptions(
                offset=len(transactions)
              )
  )
  response = client.processor_transactions_get(request)
  transactions.extend(response['transactions'])
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`const iso8601TimeFormat = "2006-01-02"
startDate := time.Now().Add(-365 * 24 * time.Hour).Format(iso8601TimeFormat)
endDate := time.Now().Format(iso8601TimeFormat)

request := plaid.NewProcessorTransactionsGetRequest(
  processorToken,
  startDate,
  endDate,
)

options := plaid.ProcessorTransactionsGetRequestOptions{
  Count:  plaid.PtrInt32(100),
  Offset: plaid.PtrInt32(0),
}

request.SetOptions(options)

transactionsResp, _, err := client.PlaidApi.ProcessorTransactionsGet(ctx).ProcessorTransactionsGetRequest(*request).Execute()

`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`startDate := time.Now().Add(-365 * 24 * time.Hour)
endDate := time.Now()

request := &plaid.ProcessorTransactionsGetRequest{
    ProcessorToken: processorToken,
    StartDate:      startDate,
    EndDate:        endDate,
}

options := plaid.ProcessorTransactionsGetRequestOptions{
    Count:  plaid.Int(100),
    Offset: plaid.Int(0),
}

request.Options = &options

transactionsResp, err := client.Processor.GetTransactions(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/transactions/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processortransactionsrecurringget"
    }}>{`/processor/transactions/recurring/get`}</h4>
    <Schema method='POST' route='/processor/transactions/recurring/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/transactions/recurring/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/transactions/recurring/get \\
-H 'Content-Type: application/json' \\
-d '{
     "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
     "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
     "processor_token":"processor-sandbox-12345678-1234-abcd-9c8f-fd5406010eee"
    }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorTransactionsRecurringGetRequest = {
  processor_token: processorToken
};
try {
  const response = await client.processorTransactionsRecurringGet(request);
  let inflowStreams = response.data.inflow_streams;
  let outflowStreams = response.data.outflow_streams;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorTransactionsRecurringGetRequest(
  processor_token=processor_token
)
response = client.processor_transactions_recurring_get(request)
inflow_streams = response.inflow_streams
outflow_streams = response.outflow_streams
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorTransactionsRecurringGetRequest.new(
  {
    processor_token: processor_token
  }
)
response = client.processor_transactions_recurring_get(request)
inflow_streams = response.inflow_streams
outflow_streams = response.outflow_streams
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorTransactionsRecurringGetRequest request = new ProcessorTransactionsRecurringGetRequest()
  .processorToken(processorToken);
Response<ProcessorTransactionsRecurringGetResponse>
  response = plaidClient.processorTransactionsRecurringGet(request).execute();

List<TransactionStream> inflowStreams = new ArrayList <TransactionStream>();
inflowStreams.addAll(response.body().getInflowStreams());
List<TransactionStream> outflowStreams = new ArrayList <TransactionStream>();
outflowStreams.addAll(response.body().getOutflowStreams());
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorTransactionsRecurringGetRequest(
  processorToken,
)
response, _, err := client.PlaidApi.ProcessorTransactionsRecurringGet(ctx).ProcessorTransactionsRecurringGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorTransactionsRecurringGetRequest{ProcessorToken: processorToken}
response, err := client.Processor.GetRecurringTransactions(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/transactions/recurring/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "processortransactionsrefresh"
    }}>{`/processor/transactions/refresh`}</h4>
    <Schema method='POST' route='/processor/transactions/refresh' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/processor/transactions/refresh' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/processor/transactions/refresh \\
 -H 'content-type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "processor_token": String
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ProcessorTransactionsRefreshRequest = {
  processor_token: processorToken,
};
try {
  await plaidClient.processorTransactionsRefresh(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ProcessorTransactionsRefreshRequest.new({ processor_token: processor_token })
response = client.processor_transactions_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ProcessorTransactionsRefreshRequest request = new ProcessorTransactionsRefreshRequest()
  .processorToken(processorToken);
Response<ProcessorTransactionsRefreshResponse> response = client()
  .processorTransactionsRefresh(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ProcessorTransactionsRefreshRequest(processor_token=processor_token)
response = client.processor_transactions_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewProcessorTransactionsRefreshRequest(processorToken)
response, _, err := client.PlaidApi.ProcessorTransactionsRefresh(ctx).ProcessorTransactionsRefreshRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ProcessorTransactionsRefreshRequest{ProcessorToken: processorToken}
response, err := client.Processor.RefreshTransactions(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/processor/transactions/refresh' type='response' mdxType="Schema" />
    <h2 {...{
      "id": "processor-webhooks"
    }}>{`Processor webhooks`}</h2>
    <h4 {...{
      "id": "webhook_update_acknowledged"
    }}><inlineCode parentName="h4">{`WEBHOOK_UPDATE_ACKNOWLEDGED`}</inlineCode></h4>
    <Schema model='ProcessorTokenWebhookUpdate' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "processoraccountget",
        level: 4,
        title: "/processor/account/get",
      },
{
        id: "processorauthget",
        level: 4,
        title: "/processor/auth/get",
      },
{
        id: "processorbalanceget",
        level: 4,
        title: "/processor/balance/get",
      },
{
        id: "processoridentityget",
        level: 4,
        title: "/processor/identity/get",
      },
{
        id: "processoridentitymatch",
        level: 4,
        title: "/processor/identity/match",
      },
{
        id: "processorinvestmentsauthget",
        level: 4,
        title: "/processor/investments/auth/get",
      },
{
        id: "processorinvestmentsholdingsget",
        level: 4,
        title: "/processor/investments/holdings/get",
      },
{
        id: "processorinvestmentstransactionsget",
        level: 4,
        title: "/processor/investments/transactions/get",
      },
{
        id: "processorsignalevaluate",
        level: 4,
        title: "/processor/signal/evaluate",
      },
{
        id: "processorliabilitiesget",
        level: 4,
        title: "/processor/liabilities/get",
      },
{
        id: "processorsignaldecisionreport",
        level: 4,
        title: "/processor/signal/decision/report",
      },
{
        id: "processorsignalreturnreport",
        level: 4,
        title: "/processor/signal/return/report",
      },
{
        id: "processorsignalprepare",
        level: 4,
        title: "/processor/signal/prepare",
      },
{
        id: "processortokenwebhookupdate",
        level: 4,
        title: "/processor/token/webhook/update",
      },
{
        id: "processortransactionssync",
        level: 4,
        title: "/processor/transactions/sync",
      },
{
        id: "processortransactionsget",
        level: 4,
        title: "/processor/transactions/get",
      },
{
        id: "processortransactionsrecurringget",
        level: 4,
        title: "/processor/transactions/recurring/get",
      },
{
        id: "processortransactionsrefresh",
        level: 4,
        title: "/processor/transactions/refresh",
      },
{
        id: "processor-webhooks",
        level: 2,
        title: "Processor webhooks",
      },
{
        id: "webhook_update_acknowledged",
        level: 4,
        title: "WEBHOOK_UPDATE_ACKNOWLEDGED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
